import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignInComponent } from './view/auth/signin/signin.component';
import { SignUpComponent } from './view/auth/signup/signup.component';
import { RestoreComponent } from './view/auth/restore/restore.component';
import { PersonalComponent } from './view/personal/personal.component';
import { OnlineComponent } from './view/online/online.component';
import { EventsComponent } from './view/events/events.component';
import { StateComponent } from './view/state/state.component';
import { TracksComponent } from './view/tracks/tracks.component';
import { ReportsComponent } from './view/reports/reports.component';
import { GeozoneComponent } from './view/geozone/geozone.component';
import { ServicesComponent } from "./view/services/services.component";
import { ShareRequestsComponent } from './view/share-requests/share-requests.component';

import { MainGuard, AuthGuard, SignUpGuard, PersonalGuard, MainNoDeviceGuard } from './guards';
import {DeleteUserComponent} from "./view/auth/deleteUser/deleteUser.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: '/signin',
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'signin',
    component: SignInComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'signup',
    component: SignUpComponent,
    canActivate: [SignUpGuard]
  },
  {
    path: 'restore',
    component: RestoreComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'personal/:userId',
    component: PersonalComponent,
    canActivate: [PersonalGuard]
  },
  {
    path: 'share-requests',
    component:ShareRequestsComponent    ,
    canActivate: [MainNoDeviceGuard]
  },
  {
    path: 'online',
    component: OnlineComponent,
    canActivate: [MainGuard],
    pathMatch: 'full'
  },
  {
    path: 'account-delete',
    component: DeleteUserComponent,
    canActivate: [PersonalGuard],
    pathMatch: 'full'
  },
  // {
  // 	path: 'online/:id/state',
  // 	component: OnlineComponent,
  // 	canActivate: [MainGuard],
  // 	pathMatch: 'full'
  // },
  {
    path: 'online/:objectId/:deviceId',
    component: OnlineComponent,
    canActivate: [MainGuard],
    children: [

      { path: 'events', component: EventsComponent },
      { path: 'tracks', component: TracksComponent },
      { path: 'state', component: StateComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'geozone', component: GeozoneComponent },
      { path: 'services', component: ServicesComponent },
    ]
  },


  { path: '**', redirectTo: '/signin' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [
    RouterModule
  ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts